import React from 'react';
import './DeleteConfirmationDialog.css';

const DeleteConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  productName = 'this product',
  productId 
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-confirmation-overlay" onClick={onClose}>
      <div className="delete-confirmation-dialog" onClick={(e) => e.stopPropagation()}>
        {/* Golden Header */}
        <div className="delete-confirmation-header">
          <div className="delete-confirmation-icon">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          <h2 className="delete-confirmation-title">Confirm Deletion</h2>
        </div>

        {/* Content */}
        <div className="delete-confirmation-content">
          <div className="delete-warning-text">
            <p className="warning-main">
              Are you sure you want to delete <strong>"{productName}"</strong>?
            </p>
            <p className="warning-sub">
              This action cannot be undone and will permanently remove the product from your store.
            </p>
          </div>

          {/* Product Info */}
          <div className="product-info-card">
            <div className="product-info-icon">
              <i className="fas fa-box"></i>
            </div>
            <div className="product-info-details">
              <div className="product-info-name">{productName}</div>
              <div className="product-info-id">ID: {productId}</div>
            </div>
          </div>

          {/* Warning Icons */}
          <div className="warning-icons">
            <div className="warning-icon-item">
              <i className="fas fa-trash"></i>
              <span>Permanent Deletion</span>
            </div>
            <div className="warning-icon-item">
              <i className="fas fa-ban"></i>
              <span>Cannot Be Undone</span>
            </div>
            <div className="warning-icon-item">
              <i className="fas fa-exclamation"></i>
              <span>All Data Lost</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="delete-confirmation-actions">
          <button 
            className="delete-cancel-btn"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
            <span>Cancel</span>
          </button>
          <button 
            className="delete-confirm-btn"
            onClick={onConfirm}
          >
            <i className="fas fa-trash"></i>
            <span>Delete Product</span>
          </button>
        </div>

        {/* Footer Warning */}
        <div className="delete-confirmation-footer">
          <p>
            <i className="fas fa-info-circle"></i>
            This action will immediately remove the product from your store and cannot be reversed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationDialog;
